/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*
*/

import { HttpParams } from "@angular/common/http";
import { RboChart } from "@src/app/modules/agent/agent-dashboard-page/RboChart";

export class RboMyOmcChart extends RboChart {
    title = "My Busiest OMCs by Request";
    dataParams = new HttpParams().set('week', 0).set('show', 'myomcs');
}
